import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./SignUp.css";

const ResetPasswordWithPhone = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const phone = location.state?.phone || "";

  const handleResetPassword = async () => {
    const newErrors = {};
    if (!otp || otp.length !== 4) newErrors.otp = "Enter 4 digit OTP.";
    if (!password) newErrors.password = "Password is required.";
    if (!confirmPassword) newErrors.confirmPassword = "Confirm password is required.";
    if (password !== confirmPassword) newErrors.confirmPassword = "Passwords do not match.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});
    setSuccessMessage("");

    try {
      const formData = new FormData();
      formData.append("token", otp);
      formData.append("password", password);
      formData.append("confrim_password", confirmPassword);

      // Example API endpoint, replace with actual
      const response = await fetch(
        `${API_BASE_URL}/reset-password`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();

      if (response.ok && data.statusCode === 1) {
        setSuccessMessage("Your password has been successfully reset. Please login with new password.");
      } else {
        setErrors({ api: data.statusMessage || "An error occurred. Please try again." });
      }
    } catch (error) {
      setErrors({ api: "An unexpected error occurred. Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        {successMessage ? (
          <div className="text-center py-5">
            <div style={{ fontSize: 60, color: '#28a745', marginBottom: 16 }}>
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#e6f9ed"/>
                <path d="M7 13.5L11 17L17 9.5" stroke="#28a745" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h4 className="mb-3" style={{ color: '#28a745' }}>Success!</h4>
            <div className="success mb-3">{successMessage}</div>
            <div style={{ color: '#555', fontSize: 15 }}>
              You can now login with your new password.
            </div>
            <button className="btn btn-primary mt-4" onClick={() => navigate("/")}>Go to Login</button>
          </div>
        ) : (
          <>
            <h2 className="signup-title">Reset Password (Phone)</h2>
            <input
              type="text"
              className="form-control"
              placeholder="Enter 4 digit OTP"
              value={otp}
              maxLength={4}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
            />
            {errors.otp && <div className="error">{errors.otp}</div>}

            <div className="input-group mt-3" style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Enter your new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ paddingRight: "40px" }}
              />
              <div
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "40%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  zIndex: 9999,
                  color: "#6c757d"
                }}
                onClick={() => setShowPassword((v) => !v)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </div>
            </div>
            {errors.password && <div className="error">{errors.password}</div>}

            <div className="input-group mt-3" style={{ position: "relative" }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                placeholder="Confirm your new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ paddingRight: "40px" }}
              />
              <div
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  zIndex: 9999,
                  color: "#6c757d"
                }}
                onClick={() => setShowConfirmPassword((v) => !v)}
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </div>
            </div>
            {errors.confirmPassword && <div className="error">{errors.confirmPassword}</div>}

            {errors.api && <div className="error">{errors.api}</div>}

            <button
              className="btn btn-success mt-3"
              onClick={handleResetPassword}
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>

            <div className="redirect-link mt-3">
              Remembered your password?{" "}
              <span className="login-link" onClick={() => navigate("/")}>Login</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordWithPhone;
